const isSafeReturnTo = returnTo =>
  typeof returnTo === "string" && returnTo.startsWith("/") && !returnTo.startsWith("//");

export const buildLoginRedirectUrl = location => {
  if (!location?.pathname) return "/login";

  const returnTo = `${location.pathname}${location.search || ""}${location.hash || ""}`;
  if (!isSafeReturnTo(returnTo)) return "/login";

  return `/login?returnTo=${encodeURIComponent(returnTo)}`;
};

export const getReturnToFromLocation = location => {
  const returnTo = new URLSearchParams(location?.search || "").get("returnTo");
  return isSafeReturnTo(returnTo) ? returnTo : null;
};
